import React, { useState } from 'react';
import { Button, notification } from 'antd';
import { get } from 'lodash';

import { FormInput } from '../../../components';
import Login from '../../../service/user/login';

function LoginPage() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');

  const submitLogin = async () => {
    try {
      await Login.call({ login, password, otp });
      window.location.reload();
    } catch (e) {
      notification.error({ title: get(e, 'response.data.message') || e.message });
    }
  };

  return (
    <div className="xchange-page xchange-page--narrow">
      <div style={{ textAlign: 'center', margin: '32px 0' }}>
        <h1>XChange Admin Panel</h1>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: 400 }}>
          <form
            style={{ padding: 16 }}
            onSubmit={(e) => {
              e.preventDefault();
              submitLogin();
            }}
          >
            <FormInput name="email" type="text" onChange={({ target: { value } }) => setLogin(value)} label="Login" />
            <FormInput
              name="password"
              type="password"
              onChange={({ target: { value } }) => setPassword(value)}
              label="Password"
            />
            <br />
            <div>
              <FormInput
                name="otp"
                type="password"
                onChange={({ target: { value } }) => setOtp(value)}
                label="One Time Password (OTP)"
              />
              <i>Enter this only if you configured 2FA</i>
            </div>
            <hr />
            <Button type="primary" style={{ width: '100%' }} htmlType="submit">
              Login
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
